import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../../services/api";
import toastOptions from "../../../utils/toastOptions";
import CongregationChart from "../../congregation/congregation-chart/CongregationChart";
import YouthChartAge from "../youth-chart-age/YouthChartAge";

export default function DashboardUmadeub() {
  const [totalYouths, setTotalYouths] = useState<number>();

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    try {
      let params = {
        page: 1,
        limit: 1,
      } as any;
  
      const { data } = await api.get(`/youths`, {
        params: params,
      });
  
      setTotalYouths(data.total);
  
    } catch (e: any) {
      e.messages?.forEach((m: string) => {
        toast.warning(m, toastOptions);
      });
  
      setTotalYouths(0);
    }
  }
  
  return (
    <div
      id="page-dashboad-event"
      className="uk-section uk-section-muted uk-padding-small"
    >
      <div className="uk-container">
        <div className="uk-grid-small uk-margin-bottom" uk-grid="true">
          <div className="uk-width-1-2@s">
            <div className="uk-card uk-card-primary uk-card-small uk-card-hover">
              <div className="uk-card-header">
                <div className="uk-grid-small uk-flex-middle" uk-grid="true">
                  <div className="uk-width-expand">
                    <h3 className="uk-card-title uk-margin-remove-bottom">Jovens Ativos</h3>
                  </div>
                </div>
              </div>
              <div className="uk-card-body">
                {
                  (totalYouths == undefined) ? 
                    <div uk-spinner="true; ratio:2">Carregando...</div>
                  :
                    <h1 className="uk-heading-xlarge">{totalYouths}</h1>
                }
              </div>
              <div className="uk-card-footer">
                <Link to="/jovens">Ver Jovens <span uk-icon="arrow-right"></span></Link>
              </div>
            </div>
          </div>
          <div className="uk-width-1-2@s uk-margin-top uk-padding">
            <div className="uk-card uk-card-body uk-card-success uk-flex uk-flex-middle uk-flex-center uk-card-hover">
              <div className="uk-inline-clip uk-transition-toggle">
                <div className="uk-transition-scale-up uk-transition-opaque">
                  <Link to="/jovens/novo" className="uk-button">
                    <div className="uk-transition-scale-up uk-transition-opaque">
                      <span uk-icon="icon: plus; ratio: 2"></span>
                      <br/>
                      Adicionar Jovem
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="uk-width-1-2@s">
            <CongregationChart type="youth"/>
          </div>
          <div className="uk-width-1-2@s">
            <YouthChartAge />
          </div>
        </div>
      </div>
    </div>
  );
}
